import { z } from 'zod';

import {
  zodProposedChangesSchema,
  zodSupplierRespondActionSchema,
} from '../validations';

// Re-export shared validations used by this hook
export { zodSupplierActionResponseSchema } from '../validations';

export const zodSupplierRespondPayloadSchema = z.object({
  action: zodSupplierRespondActionSchema,
  notes: z.string().trim().nullish(),
  proposedChanges: zodProposedChangesSchema.nullish(),
  token: z.string().min(10),
});
